import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { compose } from 'recompose';
import {
  CheckableLabeledImage,
  ImageQuestionGridContainer,
} from '@nextiva/engagement-ui';

import StylingTextOptionToRTEProps from 'styling/hocs/StylingToRTEProps/StylingTextOptionToRTEProps';
import { checkableInputTypes } from 'sharedParts/config/blockConfig/settings/checkableInputTypes';
import personalLabelMap, {
  personalLabelProptypes,
} from 'sharedParts/config/personalLabelMap';

import getSubLabelByType from '../../../../utils/getSubLabelByType';
import getRichContentFromOptionModel from '../../utils/getRichContentFromOptionModel';
import QuestionErrorMessage from '../../QuestionErrorMessage';
import withNewKeyOnLocalFontChange from '../../../../domains/styling/hocs/withNewKeyOnLocalFontChange';
import { getMirroredValue } from '../../../../utils/getMirroredValue';

class ImageRadioGroupField extends Component {
  static propTypes = {
    styling: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    size: PropTypes.string,
    layout: PropTypes.string,
    options: PropTypes.array.isRequired,
    personalLabelType: personalLabelProptypes,
    labelLayout: PropTypes.string.isRequired,
    renderKey: PropTypes.string.isRequired,
    defaultFontSize: PropTypes.number.isRequired,
    defaultFont: PropTypes.string.isRequired,
    defaultFontColor: PropTypes.string.isRequired,
    defaultBold: PropTypes.bool.isRequired,
    defaultItalic: PropTypes.bool.isRequired,
    defaultUnderline: PropTypes.bool.isRequired,
  };

  handleChange = option => () => {
    const {
      input: { onChange },
    } = this.props;
    onChange(option);
  };

  normalizeValue(value) {
    return this.props.personalLabelType === personalLabelMap.numberDesc
      ? getMirroredValue({
          value,
          min: 0,
          max: this.props.options.length - 1,
        })
      : value;
  }

  render() {
    const {
      input: { value },
      meta,
      size,
      layout,
      options,
      labelLayout,
      personalLabelType: labelType,
      renderKey,
      defaultFontSize,
      defaultFont,
      defaultFontColor,
      defaultBold,
      defaultItalic,
      defaultUnderline,
      styling: { selectionColor },
    } = this.props;

    return (
      <div>
        <QuestionErrorMessage fieldMeta={meta} />
        <ImageQuestionGridContainer size={size} layout={layout}>
          {options.map((option, index) => (
            <CheckableLabeledImage
              key={option.id + renderKey}
              e2e={'image-question-option'}
              src={option.src}
              checkedColor={selectionColor}
              size={size} // need for IE11 css grid-support @sinslav
              layout={layout} // need for IE11 css grid-support @sinslav
              content={getRichContentFromOptionModel(option)} // migrating plain to rich text @sinslav
              type={checkableInputTypes.radio}
              labelLayout={labelLayout}
              subLabel={getSubLabelByType({
                labelType,
                index: this.normalizeValue(index),
              })}
              onChange={this.handleChange(option)}
              checked={get(value, 'id') === option.id}
              defaultFontSize={defaultFontSize}
              defaultFont={defaultFont}
              defaultFontColor={defaultFontColor}
              defaultBold={defaultBold}
              defaultItalic={defaultItalic}
              defaultUnderline={defaultUnderline}
            />
          ))}
        </ImageQuestionGridContainer>
      </div>
    );
  }
}

export default compose(
  StylingTextOptionToRTEProps,
  withNewKeyOnLocalFontChange,
)(ImageRadioGroupField);
